"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageLayout1ColumnOnly = exports.pageLayoutHpOnly = void 0;
function pageLayoutHpOnly(style) {
    return "\n    .wpthemeUnipol & {\n      ".concat(style, "\n    }\n  ");
}
exports.pageLayoutHpOnly = pageLayoutHpOnly;
function pageLayout1ColumnOnly(style) {
    return "\n    .wptheme1Col & {\n      ".concat(style, "\n    }\n  ");
}
exports.pageLayout1ColumnOnly = pageLayout1ColumnOnly;
